/** @format */

import CloseIcon from '@/assets/icons/joivy_plp_close.svg';
import { useToggleZendeskWidget } from '@/ducks/general/hooks/useToggleZendeskWidget';
import React, { FunctionComponent as FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from '../../Icon';
import { BottomSheet, BottomSheetCloseButton, BottomSheetContent, BottomSheetHeader } from './index.style';

export const SlideBottomSheet: FC<SlideBottomSheetProps> = ({ children, label, onClose, isOpen }) => {
  useToggleZendeskWidget(true);

  return createPortal(
    <BottomSheet $open={isOpen}>
      <BottomSheetHeader>
        <BottomSheetCloseButton onClick={onClose}>
          <Icon icon={CloseIcon} width={20} height={20} />
        </BottomSheetCloseButton>
        <p>{label}</p>
      </BottomSheetHeader>
      <BottomSheetContent>{children}</BottomSheetContent>
    </BottomSheet>,
    document.body,
  );
};

export interface SlideBottomSheetProps {
  children: ReactNode;
  label: string;
  onClose: () => void;
  isOpen: boolean;
}
